import baseAPI from '@/api';
import { Success } from '@starsoft/common/models';

export async function fetchDailyUserAccess() {
  const response = await baseAPI.post<Success>(`/user-trackings`);
  return response.data;
}
